import React, { Component } from 'react';
import ensembl from "./images/buttons/ensembl.png";
import ncbi from "./images/buttons/ncbi.png";
import snpedia from "./images/buttons/snpedia.png";
import google from "./images/buttons/google.png";

class SnpButtons extends Component {
  render() {
    const url_list = [
      {
        "img":ensembl,
        "url":"http://grch37.ensembl.org/Homo_sapiens/Variation/Explore?v=%s;vdb=variation"
      },
      {
        "img":ncbi,
        "url":"http://www.ncbi.nlm.nih.gov/snp/?term=%s&SITE=NcbiHome&submit=Go"
      },
      {
        "img":snpedia,
        "url":"http://www.snpedia.com/index.php/%s"
      },
      {
        "img":google,
        "url":"https://scholar.google.com/scholar?q=%s"
      }
    ];

    var buttons_list = [];

    for (var i=0;i<url_list.length;i++) {
      buttons_list.push(
        <a href={url_list[i]["url"].replace("%s",this.props.snp)}
          key={i}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={url_list[i]["img"]} alt=""/>
        </a>
      );
    }

    return (
      <div className="buttons">
        {buttons_list}
      </div>
    )
  }
}

export default SnpButtons;